
export const domainUrl = "okzhuan.com"; // 主域名

export const isDev = process.env.NODE_ENV === "development" || window.location.host.indexOf("lkdev-") > -1; // 是否为开发环境

export const prefix = isDev ? "lkdev-" : ""; // 前缀域名
// 生成URL的辅助函数
const buildUrl = (path, isWs = false) => {
    const protocol = isWs ? "wss://" : "https://";
    return `${protocol}${prefix}${path}.${domainUrl}/`;
};

export const apiUrl = buildUrl("api"); // api
export const BaseUrl = buildUrl("app");//业务域名
export const appsUrl = buildUrl("apps");//业务域名
export const resourceUrl = buildUrl("resourceUrl"); // 资源域名
export const WwwUrl = buildUrl("www"); // 官网域名


